export default __webpack_public_path__ + "static/media/HIGIENICO.ef790e7a.svg";